"use client";
import React, { useEffect, useState } from "react";
import { sendDownloadEvent } from "../../../ga4/eventHandler";

export default function MachineManuals({ machine }) {
  let data = machine.manuals;

  return (
    <div className="manuals-wrapper">
      {data.map((manual) => (
        <div
          className="manual"
          key={manual.id}
          onClick={() => {
            sendDownloadEvent(machine.name, manual.manual_type.data.attributes);
            window.open(manual.url, "_blank");
          }}
        >
          <div className="manual-image-wrapper">
            <ManualSVG
              url={manual.manual_type.data.attributes.image.data.attributes.url}
              alternativeText={
                manual.manual_type.data.attributes.image.data.attributes
                  .alternativeText || "Kodiak Manual Image"
              }
            />
          </div>
          <h4>{manual.manual_type.data.attributes.name}</h4>
        </div>
      ))}
    </div>
  );
}

function ManualSVG({ url, alternativeText }) {
  const [svgContent, setSvgContent] = useState(null);

  useEffect(() => {
    fetchSVGContent(url).then((content) => {
      setSvgContent(content);
    });
  }, [url]);

  const fetchSVGContent = async (svgUrl) => {
    try {
      const response = await fetch(svgUrl);
      const svg = await response.text();
      return svg;
    } catch (error) {
      console.error("Failed to fetch SVG:", error);
      return null;
    }
  };

  if (!svgContent) return null;

  return (
    <div
      dangerouslySetInnerHTML={{ __html: svgContent }}
      aria-label={alternativeText}
    />
  );
}
